import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal } from '_zari/core'

import * as ProyectoService from 'services/proyecto.service'

import * as FormGroups from './formGroups'
import ValidationSchema from './validation'

const InsertarActualizarProyectoModal = ({ handleClose, show, refreshTable, editarData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      codigo: editarData.codigo ?? '',
      descripcion: editarData.descripcion ?? '',
      moneda: editarData.moneda ?? ''
    }),
    [editarData]
  )

  const submitHandler = React.useCallback(
    (data, { setSubmitting }) => {
      const submitFunction = editarData._id
        ? () => ProyectoService.actualizarxId(editarData._id, data)
        : () => ProyectoService.nuevo(data)

      submitFunction()
        .then(() => {
          __zariContext.toast('success', 'El registro se ha guardado.')
          refreshTable()
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, editarData, refreshTable, handleClose]
  )

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>{editarData._id ? 'EDITAR PROYECTO' : 'NUEVO PROYECTO'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched }) => (
          <Form>
            <Modal.Body>
              <FormGroups.CodigoFormGroup
                iError={errors.codigo}
                iTouched={touched.codigo}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.DescripcionFormGroup
                iError={errors.descripcion}
                iTouched={touched.descripcion}
                fIsSubmitting={isSubmitting}
              />
              <FormGroups.MonedaFormGroup
                iError={errors.moneda}
                iTouched={touched.moneda}
                fIsSubmitting={isSubmitting}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>{editarData._id ? 'Actualizar' : 'Crear'}</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(InsertarActualizarProyectoModal)
